// --- DANGER - DO NOT EDIT BETWEEN THESE LINES ---
import $ from "jquery";
import "srcdoc-polyfill";
import "babel-polyfill";

//allow browser back and forward actions reload the page
window.onpopstate = (()=>{
    window.location.reload();
});

$(document).ready(() => {
    if (window.Rollbar) {
        $.ajax({
            method: "GET",
            url: "/api/customers/me"
        }).done(function(response) {
            var replacer = new RegExp("^([^@]{2})[^@]+", "i");
            var person = {
                id: response.id,
                username: `${String(response.firstname || "Anony").replace(replacer, "$1*")} ${String(response.lastname || "Moose").replace(replacer, "$1*")}`.toLowerCase().replace(/[^a-z0-9]{1,}/gi, ""),
                email: response.email.replace(replacer, "$1*")
            };

            window.Rollbar.configure({
                payload: {
                    person: person
                }
            });
        });
    }

    $(function() {
        $("select#showPerPage").change(e => {
            const { value } = e.target;
            let params = (new URL(document.location)).searchParams;

            params.set("pageSize", value);
            location.search = params.toString();
        });
    });

    if(window.sessionStorage) {
        if (!window.sessionStorage.getItem("ip_address")) {
            $.get("/api/ip").then(ip => {
                window.sessionStorage.setItem("ip_address", ip);
            });
        }
    }

    // add Equipment Page Class for Category Pages.
    $(function() {
        if (window.location.href.indexOf("/equipment") > -1) {
            $("#catalog").addClass("equipment-page");
            $( ".equipment-page .searchTitle" ).appendTo( ".mainSearchTitle" );
        }
    });

    // add search class for styling on search pages
    $(function() {
        if (window.location.href.indexOf("search") > -1) {
            $("#catalog").addClass("search-page");
        }
    });

    var cintval = setInterval(function () {
        var iframe = ".product-detail-description";

        if ($(iframe).length) {
            var cont = $(iframe).contents().find("html").height();

            $(iframe).css("height", cont + "px");
            clearInterval(cintval);
        }
    }, 300);

    $(function() {
        const frame = document.querySelector("iframe.product-detail-description");

        if(frame) {
            var body = frame.contentWindow.document.querySelector("body");

            body.style.fontFamily = "'Source Sans Pro', Helvetica, Arial, sans-serif";
        }
    });

    if ($(window).innerWidth() < 576 && $(".breadcrumbList").length) {
        // For some reason this wouldn't work on refresh without a timeout 🤷
        setTimeout(() => {
            $(".breadcrumbList").scrollLeft($(".breadcrumbList").width());
        }, 10);
    }
});

// foreach polyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
if (!Array.prototype.forEach) {

    Array.prototype.forEach = function (callback/*, thisArg*/) {

        var T, k;

        if (this == null) {
            throw new TypeError("this is null or not defined");
        }

        // 1. Let O be the result of calling toObject() passing the
        // |this| value as the argument.
        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get() internal
        // method of O with the argument "length".
        // 3. Let len be toUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If isCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== "function") {
            throw new TypeError(callback + " is not a function");
        }

        // 5. If thisArg was supplied, let T be thisArg; else let
        // T be undefined.
        if (arguments.length > 1) {
            T = arguments[1];
        }

        // 6. Let k be 0.
        k = 0;

        // 7. Repeat while k < len.
        while (k < len) {

            var kValue;

            // a. Let Pk be ToString(k).
            //    This is implicit for LHS operands of the in operator.
            // b. Let kPresent be the result of calling the HasProperty
            //    internal method of O with argument Pk.
            //    This step can be combined with c.
            // c. If kPresent is true, then
            if (k in O) {

                // i. Let kValue be the result of calling the Get internal
                // method of O with argument Pk.
                kValue = O[k];

                // ii. Call the Call internal method of callback with T as
                // the this value and argument list containing kValue, k, and O.
                callback.call(T, kValue, k, O);
            }
            // d. Increase k by 1.
            k++;
        }
        // 8. return undefined.
    };
}

// nodeList Foreach polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// string.includes polyfill
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if (!String.prototype.includes) {
    Object.defineProperty(String.prototype, "includes", {
        value: function(search, start) {
            if (typeof start !== "number") {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        }
    });
}

// $(document).ready(function() {
//     $(".product-thumbnail").carousel({
//         interval: 5000
//     })
// });
